import { FC, useCallback, useMemo } from "react";
import { Close } from "@common/schemas/close.schema";
import { formatDateOnly } from "@helpers/date";
import { InjectedCommandOption } from "./lib";
import { TaskBulkOptionsCommandsList } from "./TaskBulkOptionsCommandsList";
import { useCommands } from "./useCommands";
import { useStartCloseAgent } from "./useStartCloseAgent";

interface CloseOptionParams {
    close: Close;
    entityName: string;
    onSelect: () => void;
}

function closeOption({
    close,
    entityName,
    onSelect,
}: CloseOptionParams): InjectedCommandOption {
    const period = `${formatDateOnly(close.startDate)} – ${formatDateOnly(close.endDate)}`;
    return {
        id: `close-${close.id}`,
        label: entityName,
        sublabel: `${close.name} · ${period}`,
        keywords: [entityName, close.name, period],
        onSelect,
    };
}

export const AgentRunCloseCommandsList: FC = () => {
    const { close: closeCommands } = useCommands();
    const { openCloses, entityName, start } = useStartCloseAgent();

    const select = useCallback(
        (close: Close) => {
            closeCommands();
            start(close);
        },
        [closeCommands, start],
    );

    const options = useMemo(
        () =>
            openCloses.map((close) =>
                closeOption({
                    close,
                    entityName: entityName(close),
                    onSelect: () => select(close),
                }),
            ),
        [openCloses, entityName, select],
    );

    return <TaskBulkOptionsCommandsList heading="Closes" options={options} />;
};
